import React from "react";
const RenderButton = ({ disabled = false,label, onClick, className, value, key=0 ,style }) => {
  return (
    <>
    <button disabled = {disabled}  key={key} type="button" 
    style={{
       borderWidth:1,
       alignItems:'center',
       justifyContent:'center',
       width:180,
       height:35,
      borderRadius:25,
    }}
    onClick={onClick} value={value}
     className={className +" mb-1" } >
      {label}     
    </button>
    </>
  );
};

export default RenderButton;
